import router from 'Profile/js/router';
import store from 'Site/js/store';
import Vue from 'vue';
import VueRouter from 'vue-router';
import pagination from 'Site/js/mixin/pagination.input.check';
import profileHeader from 'Profile/mixin/profileHeader';
import FollowPanel from 'Profile/component/FollowPanel.vue';

export default function () {
    Vue.use(VueRouter);

    new Vue({ /* eslint no-new: 0 */
        el: '#profile-vue',
        name: 'FollowPanel',
        router,
        store,
        mixins: [pagination, profileHeader],
        components: {
            FollowPanel,
        }
    });
}
